import { useState, useEffect } from "react";
import AnnouncementsBanner from "./AnnouncementsBanner";
const GetAnnouncementsData=()=> {
    const [announcements, setAnnouncements] = useState([]);
    useEffect(() => {
        // Fetch the announcements file directly
        fetch('protected-data/announcements.json')
            .then(res => res.json())
            .then((data) => {
                const now = new Date();
                const activeAnnouncements = data.announcements.filter(a => {
                    const start = new Date(a.start_date);
                    const end = new Date(a.end_date);
                    return start <= now && now <= end;
                });
                const sortedAnnouncementsByDate = activeAnnouncements.sort((a, b) => new Date(b.start_date).getTime() - new Date(a.start_date).getTime());
                setAnnouncements(sortedAnnouncementsByDate);
            });
    }, []);
    return announcements.length === 0 ? null : <AnnouncementsBanner announcements={announcements} />;

};

export default GetAnnouncementsData;